import { FC } from 'react';
import { DetailsBooking } from 'types';
import { getStayRatingForBookingId } from 'lib/stayRating';
import { getUpdatePaymentMethodPageLink } from 'lib/links';
import StateMessaging from '../BookingDetails/StateMessaging';
import StayRating from '../BookingDetails/StayRating';
import { FailedScheduledPaymentContainer } from '../Alerts/Inline/FailedScheduledPayment';
import { ScheduledPaymentCreditCardExpiredContainer } from '../Alerts/Inline/ScheduledPaymentCreditCardExpired';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';
import { PaymentMethodUpdateRequired } from '../Alerts/Inline/PaymentMethodUpdateRequired';
import { showPaidByQantasTravelPass, showDepositPayAdyenMigrationInfo } from '../helpers';
import QantasPassNotification from './components/QantasPassNotification';

interface BookingDetailsProps {
  booking: DetailsBooking;
}

const BookingNotifications: FC<BookingDetailsProps> = ({ booking }) => {
  const rating = getStayRatingForBookingId(booking.id);
  const showPaymentMethodUpdateRequired = showDepositPayAdyenMigrationInfo(booking);
  const showQantasPassNotification = showPaidByQantasTravelPass(booking);

  return (
    <>
      {showQantasPassNotification && <QantasPassNotification />}
      {showPaymentMethodUpdateRequired && (
        <PaymentMethodUpdateRequired updatePaymentMethodUrl={getUpdatePaymentMethodPageLink(booking.id)} />
      )}
      <StateMessaging booking={booking} />
      <InPathFlightBookingAlert />
      <FailedScheduledPaymentContainer />
      <ScheduledPaymentCreditCardExpiredContainer />
      {booking.flags.isRateable && !rating && <StayRating booking={booking} />}
    </>
  );
};

export default BookingNotifications;
